module.exports = {"410622001":"朝歌街道","410622002":"桥盟街道","410622003":"卫都街道","410622004":"灵山街道","410622101":"高村镇","410622102":"北阳镇","410622103":"西岗镇","410622104":"庙口镇","410622202":"黄洞乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410622.json
// module id = 1449
// module chunks = 0